export default __webpack_public_path__ + "static/media/virtual-bg20.719d9067.png";